import { API_BASE_URL } from './api/config';

export const saveUserDemoInfo = async (full_name, phone_number, email) => {
  try {
    const response = await fetch(`${API_BASE_URL}/users/submit`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        full_name,
        phone_number,
        email,
        field: 'Demo Request',
        salary: 'Not Specified',
      }),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || `HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    console.log('Demo user info saved successfully:', data);
    return data;
  } catch (error) {
    console.error("Error saving user demo info:", error);
    return null;
  }
};